/* eslint-disable no-console */

// Proxied base (setupProxy rewrites /kc -> https://dch-november.context64.ai/auth)
const KC_BASE = "/kc";
const KC_REALM = "dch";
const KC_CLIENT_ID = "dch-dch";

// ⚠️ Demo-only: hardcoded creds (move server-side for prod)
const USERNAME = "dch-admin";
const PASSWORD = "6l7jLG80RYpCH0IaA9FHx9IS";

/**
 * Direct Grant login → returns:
 * { access_token, refresh_token, expires_in, refresh_expires_in, token_type, ... }
 */
export async function getTokens() {
  const url = `${KC_BASE}/realms/${KC_REALM}/protocol/openid-connect/token`;

  const r = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({
      client_id: KC_CLIENT_ID,
      grant_type: "password",
      username: USERNAME,
      password: PASSWORD,
    }),
  });

  if (!r.ok) {
    const text = await r.text().catch(() => "");
    throw new Error(`Keycloak login failed: ${r.status} ${r.statusText}${text ? " - " + text : ""}`);
  }
  return r.json();
}
